export interface Language {
	readonly languageCode: string;
	readonly name: string;
}

export const Languages: Language[] = [
	{languageCode: "en-US", name: "English"},
	{languageCode: "nl-NL", name: "Nederlands"},
	{languageCode: "sv-SE", name: "Svenska"}
];
